export default class FeatureFlags {
    public static readonly Escheats: string = 'EscheatsFeature';
    public static readonly DualComp: string = 'DualCompFeature';
    public static readonly ManageSalesAndLeases: string = 'ManageSalesAndLeasesFeature';
    public static readonly SalesByState: string = 'SalesByStateFeature';
    public static readonly PetitionForWaiver: string = 'PetitionForWaiver';
    public static readonly BuildingFunds: string = 'BuildingFundFeature';
}
